import * as React from 'react';
const CloseModalContext = /*#__PURE__*/React.createContext(undefined);
export default CloseModalContext;